import React from 'react'

const Marquee = (props) => {
    return (
        <div className="digital-marque-sec">
            <div className="container">
                <div className="digital-marque">
                    <div className="marquee">
                        <div className="track">
                            <div className="content">
                                <h1><span>We always try to put our best service to our client</span> <i>.</i> <span>We always try to put our best service to our client</span> <i>.</i> <span>We always try to put our best service to our client</span> <i>.</i> <span>We always try to put our best service to our client</span> <i>.</i> 
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Marquee;